<template>
  <sweet-modal width="600px" title="Add Tax Account" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left" label-width="150px">
      <el-form-item size="mini" prop="taxAccountName" label="Tax Account Name">
        <el-input v-model="form.taxAccountName" placeholder="Tax Account Name" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item size="mini" prop="accountGroupId" label="Account Group">
        <el-select v-model="form.accountGroupId" filterable placeholder="Account Group" style="width: 100%;">
          <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              @click.native="handleSelectAccountGroup(item.id, item)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="mini" label="Sub-account of">
        <el-select v-model="form.accountId" placeholder="Sub-account of" style="width: 100%;">
          <el-option
              v-for="item in accountList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              @click.native="handleSelectAccount(item)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="mini" prop="taxTypeId" :label="$t('modal_taxLibraries')">
        <el-select v-model="form.taxTypeId" :placeholder="$t('modal_taxLibraries')" style="width: 100%;" @change="handleSelectTaxType">
          <el-option
              v-for="item in taxTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="mini" prop="taxId" :label="$t('modal_taxCode')">
        <el-select :disabled="!form.taxTypeId" filterable v-model="form.taxId" :placeholder="$t('modal_taxCode')" style="width: 100%;">
          <el-option
              v-for="item in taxes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
          <!-- :disabled="!!item.taxAccountName" -->
        </el-select>
      </el-form-item>
      <el-form-item size="mini" prop="taxId" label="Account Currency">
        <el-select filterable v-model="form.accountCurrency" placeholder="Account Currency" style="width: 100%;">
          <el-option
              v-for="item in accountCurrencyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="mini" label="Opening Balance">
        <!-- <el-input v-model="form.openingBalance" placeholder="Opening Balance" size="mini" clearable></el-input> -->
        <money v-model="form.openingBalance" v-bind="money"></money>
      </el-form-item>
      <el-form-item size="mini" label="Current Balance">
        <!-- <el-input disabled v-model="form.openingBalance" placeholder="Current Balance" size="mini" clearable></el-input> -->
        <money :readonly="true" v-model="form.openingBalance" v-bind="money"></money>
      </el-form-item>
      <el-form-item size="mini" label="Account Status">
        <el-checkbox v-model="form.accountStatus">Inactive</el-checkbox>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button @click="create('form')" type="primary">{{$t('general_submit')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import {Money} from 'v-money'
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "CreateSettingTaxAccountModal",
  components: {
    SweetModal,
    Money,
  },
  data() {
    return {
      form: {
        taxAccountName: null,
        accountGroupId: null,
        accountId: null,
        taxTypeId: null,
        taxId: null,
        accountCurrency: null,
        openingBalance: 0,
        // currentBalance: null,
        accountStatus: false,
        clashflowId: null,
        filePath: null,
      },
      accountCurrencyList: [],
      taxes: [],
      groupList: [],
      accountList: [],
      rules: {
        taxAccountName: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        accountGroupId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        accountId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        taxTypeId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        taxId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ]
      },
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        masked: false
      },
      taxTypes: [
        { id: 1, name: this.$t('settings_accountThink_taxTypes_taxes') },
        { id: 2, name: this.$t('settings_accountThink_taxTypes_withholdingTaxes') }
      ],
    }
  },
  methods: {
    async openModal(){
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/account-with-tax/directories?companyId=${this.$route.query.companyId}`)
        this.groupList = response.data.data.groups
        this.accountCurrencyList = response.data.data.currencyList
        // this.subaccountofList = response.data.data.accounts
        // this.taxList = response.data.data.taxList
        this.$refs.modal.open()
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    handleSelectAccountGroup(accountGroupId, item) {
      this.accountList = []
      this.form.accountId = null
      this.form.clashflowId = item.clashflowId
      this.form.filePath = item.filePath
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/getByGroupId?groupId=${accountGroupId}`).then(response => {
        console.log(response)
        this.accountList = response.data.list
        loader.hide()
      }).catch(err => {
        console.log(err)
        loader.hide()
      })
    },
    handleSelectAccount(item) {
      this.form.clashflowId = item.clashflowId
      this.form.filePath = item.filePath
    },
    handleSelectTaxType(type) {
      this.form.taxId = null
      this.taxes = []
      let url = ''
      switch (type) {
        case 1:
          url = `/api/v1/projectTaxes/list?companyId=${this.$route.query.companyId}`
          break;
        case 2:
          url = `/api/v1/withholdingTaxes/list?companyId=${this.$route.query.companyId}`
          break;
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(url).then(response => {
        console.log(response)
        this.taxes = response.data.list
        loader.hide()
      }).catch(err => {
        console.log(err)
        loader.hide()
      })
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const payload = {
            name: this.form.taxAccountName,
            groupId: this.form.accountGroupId,
            parentId: this.form.accountId,
            taxTypeId: this.form.taxTypeId,
            taxId: this.form.taxId,
            accountCurrencyId: this.form.accountCurrency,
            amount: this.form.openingBalance,
            active: this.form.accountStatus,
            clashflowId: this.form.clashflowId,
            filePath: this.form.filePath,
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/account/create-with-tax?companyId=${this.$route.query.companyId}`, payload).then(response => {
            console.log(response)
            this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_taxSuccessfullyCreated'), "success")
            this.$refs.modal.close()
            loader.hide()
            this.$emit('loadList')
          }).catch(err => {
            console.log(err)
            loader.hide()
          })
        }
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    close() {
      this.form.taxTypeId = null
      this.form.taxId = null
      this.form.accountGroupId = null
      this.form.accountId = null
      this.form.accountCurrency = null
      this.form.openingBalance = 0
      this.form.accountStatus = null
      this.taxes = []
      this.groupList = []
      this.accountList = []
      this.accountCurrencyList = []
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>
